/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const Landscape = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path
        style={{fill: "black"}}
        d="M6.8,9.5L3.3,13C3.2,13,3.1,13.1,3,13.1V17h14v-5.1l-5.5,1.8c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.1 L6.8,9.5z M6.8,8.3c0.1,0,0.2,0.1,0.3,0.1l4.2,4.2l5.5-1.8c0,0,0.1,0,0.1,0V3H3v8.8l3.4-3.4C6.5,8.3,6.7,8.3,6.8,8.3z M3,2h14 c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3l0,0C2,2.4,2.4,2,3,2L3,2z M13.5,8.5c-1.1,0-2-0.9-2-2s0.9-2,2-2 s2,0.9,2,2S14.6,8.5,13.5,8.5z M13.5,7.5c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S12.9,7.5,13.5,7.5z"
      />
    </BaseSvgIcon>
  )
}

export default Landscape
